// import Utils from '../utils';
// import Langs from '../langs';

/**
 * Service component for showing confirmation, error, and other dialogs
 */
export default {

  visible: false,
  type: null,
  title: '',
  message: '',
  buttons: [],
  payload: null,

  show(args) {
    this.visible = true;
    this.type = args.type;
    this.message = args.message;
    this.payload = args.payload;

    this.buttons.splice(0);
    args.buttons.forEach(button => {
      this.buttons.push(button)
    })
  },

  hide() {
    this.visible = false;
  },

  execute(button) {
    button.action(this.payload)
  },

}
